module.exports = __webpack_public_path__ + "static/whiteelephant-75206b1312b78b68a62eafeabcb54cde.png";